import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import VehicleApply from '@/types/table/vehicleApply';
import { DriverData } from '@/api/generated/driverController';
import { VehicleData } from '@/api/generated/vehicleController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface VehicleApplyData extends VehicleApply {
  driver?: DriverData;
  vehicle?: VehicleData;
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class VehicleApplyController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<VehicleApplyData>>(API_CONTEXT + '/upms/vehicleApply/list', params, httpOptions);
  }
  static returnList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<VehicleApplyData>>(API_CONTEXT + '/upms/vehicleApply/return/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<VehicleApplyData>(API_CONTEXT + '/upms/vehicleApply/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/upms/vehicleApply/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/upms/vehicleApply/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/upms/vehicleApply/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/vehicleApply/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/vehicleApply/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/vehicleApply/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/vehicleApply/deleteBatch', params, httpOptions);
  }
  static audit(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/vehicleApply/audit', params, httpOptions);
  }
  static return(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/vehicleApply/return', params, httpOptions);
  }
  static startOnlyApplyAudit(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/vehicleApply/startOnly/ApplyAudit', params, httpOptions);
  }
  static startWithBusinessKeyApplyAudit(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/vehicleApply/startWithBusinessKey/ApplyAudit', params, httpOptions);
  }
  static startAndTakeUserTaskApplyAudit(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/vehicleApply/startAndTakeUserTask/ApplyAudit', params, httpOptions);
  }
  static startAndSaveDraftApplyAudit(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/vehicleApply/startAndSaveDraft/ApplyAudit', params, httpOptions);
  }
  static submitUserTaskApplyAudit(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/vehicleApply/submitUserTask/ApplyAudit', params, httpOptions);
  }
  static viewTaskBusinessDataApplyAudit(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/upms/vehicleApply/viewTaskBusinessData/ApplyAudit', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataApplyAudit(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/upms/vehicleApply/viewHistoricTaskBusinessData/ApplyAudit', params, httpOptions);
  }
  static listWorkOrderApplyAudit(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/vehicleApply/listWorkOrder/ApplyAudit', params, httpOptions);
  }
}
